// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1pXrE","search":"Settings_search__2xIA7","filter":"Settings_filter__1x-23"};